import React, { useState } from 'react';
import { Quote } from 'lucide-react';
import { imageUrl } from '../config';
import { useBlock } from './SiteContent';

const DEFAULT_AVATARS = ['review_avatar_1', 'review_avatar_2', 'review_avatar_3'];

const DEFAULT = {
  items: [
    { id: 'r1', text: 'Я долго боялась идти к психологу. С Светланой всё иначе. Она просто слушает. И от этого становится легче дышать.', author: 'Анна', age: 34 },
    { id: 'r2', text: 'После года работы у меня впервые появилось ощущение, что я знаю, чего хочу. Не от других — от своей жизни.', author: 'Мария', age: 28 },
    { id: 'r3', text: 'Пришла с тревогой и бессонницей. Никогда не давила, не давала инструкций. Просто рядом — и от этого получалось разбираться самой.', author: 'Ольга', age: 41 },
  ],
};

function Avatar({ keyName }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="w-10 h-10 rounded-full overflow-hidden bg-oat shrink-0">
      <img
        src={imageUrl(keyName)}
        alt=""
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`w-full h-full object-cover transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
}

export default function Reviews() {
  const r = useBlock('reviews', DEFAULT);
  const items = r.items?.length ? r.items : DEFAULT.items;
  return (
    <section id="reviews" className="relative py-16 md:py-24 bg-oat overflow-hidden" data-testid="reviews">
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{ backgroundImage: `url(${imageUrl('reviews_bg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />
      <div className="relative max-w-6xl mx-auto px-5 md:px-8">
        <div className="reveal text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-4 text-[12px] tracking-[0.24em] uppercase text-wine/70">
            <span className="gold-divider" />
            <span>отзывы</span>
            <span className="gold-divider" />
          </div>
          <h2 className="font-heading text-3xl md:text-[44px] text-ink leading-tight">
            Истории тех, кто здесь&nbsp;уже&nbsp;был
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {items.map((it, i) => (
            <article
              key={it.id || i}
              className="reveal bg-cream border border-ink/10 p-6 md:p-7 relative"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`review-card-${i}`}
            >
              <Quote size={28} className="absolute -top-2 left-5 text-wine/70 bg-cream px-1" strokeWidth={1.3} aria-hidden />
              <p className="font-heading italic text-[19px] leading-relaxed text-ink/90 mb-5 mt-1">
                {it.text}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-ink/10">
                <Avatar keyName={DEFAULT_AVATARS[i % 3]} />
                <div>
                  <div className="text-ink font-medium text-sm">{it.author}</div>
                  {it.age && <div className="text-xs text-ink/50">{it.age} лет</div>}
                </div>
              </div>
            </article>
          ))}
        </div>
        <p className="text-center text-xs text-ink/50 mt-7">
          Имена изменены, тексты — с&nbsp;согласия авторов.
        </p>
      </div>
    </section>
  );
}
